module.exports = __webpack_public_path__ + "media/src/assets/Images/BuildingReservation-332359ce9a15072279c8e7bd6771d616.svg";